import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, KeepAlive as _KeepAlive, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contains-loader" }
const _hoisted_2 = { class: "subtitle" }

import { UsePerformanceChart } from "./Hooks/UsePerformanceChart";
import { computed, toRefs } from "vue";
import { UseTaxonomyHelper } from "../../../Helper/Stateful/UseTaxonomyHelper";
import { IGetAllColumns, TAllTableHeaderValues } from "../../../../typings/DataFetching";
import { UseChart } from "./Hooks/UseChart";
import { storeToRefs } from "pinia";
import { UseDateStore } from "../../State/Stores/DateStore";
import { UseProgramStore } from "../../State/Stores/ProgramStore";

import PerformanceBreadcrumb from "../Breadcrumb.vue";
import Controls from "./Controls.vue";
import ExportData from "../../Pieces/ExportData.vue";
import VueApexCharts from "vue3-apexcharts";
import ChartAnnotations from "./AnnotationsNew.vue";

const __default__ = {
  name: "PerformanceChart",
  components: {
    Controls,
    ExportData,
    PerformanceBreadcrumb,
    ChartAnnotations,
    VueApexCharts,
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    chartData: null,
    loading: { type: Boolean },
    headers: null
  },
  setup(__props: any) {

const props = __props as {
  chartData: TAllTableHeaderValues<IGetAllColumns>[];
  loading: boolean;
  headers: IGetAllColumns;
}



const { chartData: data, loading: isLoading, headers } = toRefs(props);
const { dateFrom, dateTo } = storeToRefs(UseDateStore());
const { getCurrentProgramName } = storeToRefs(UseProgramStore());
const { interval, firstMetric, secondMetric, typeOfChart } = UsePerformanceChart();
const { chartOptionsCompute, metrics, showAnnotationTable, computedSeries } = UseChart();
const { taxonomyOne, taxonomyTwo, taxonomyThree, taxonomyFour } = UseTaxonomyHelper();

const exportData = computed(() => {
  return data.value?.map((d) => ({
    ...d,
    first_click_conversion_rate: +d.first_click_conversion_rate / 100,
    last_click_conversion_rate: +d.last_click_conversion_rate / 100,
    attributed_conversion_rate: +d.attributed_conversion_rate / 100,
    attributed_revenue_variance_percent: +d.attributed_revenue_variance_percent / 100,
  }));
});

return (_ctx: any,_cache: any) => {
  const _component_o_loading = _resolveComponent("o-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_o_loading, {
      class: "is-loader-overlay",
      "full-page": false,
      active: _unref(isLoading),
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (_isRef(isLoading) ? (isLoading).value = $event : null))
    }, null, 8, ["active"]),
    _createElementVNode("h2", _hoisted_2, [
      _createVNode(PerformanceBreadcrumb, {
        "taxonomy-one": _unref(taxonomyOne),
        "taxonomy-two": _unref(taxonomyTwo),
        "taxonomy-three": _unref(taxonomyThree),
        "taxonomy-four": _unref(taxonomyFour)
      }, null, 8, ["taxonomy-one", "taxonomy-two", "taxonomy-three", "taxonomy-four"])
    ]),
    _createVNode(Controls, {
      headers: _unref(headers),
      metrics: _unref(metrics),
      "first-metric": _unref(firstMetric),
      "onUpdate:first-metric": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstMetric) ? (firstMetric).value = $event : null)),
      "second-metric": _unref(secondMetric),
      "onUpdate:second-metric": _cache[2] || (_cache[2] = ($event: any) => (_isRef(secondMetric) ? (secondMetric).value = $event : null)),
      "chart-type": _unref(typeOfChart),
      "onUpdate:chart-type": _cache[3] || (_cache[3] = ($event: any) => (_isRef(typeOfChart) ? (typeOfChart).value = $event : null)),
      interval: _unref(interval),
      "onUpdate:interval": _cache[4] || (_cache[4] = ($event: any) => (_isRef(interval) ? (interval).value = $event : null)),
      "show-annotations": "",
      "show-annotations-table": _unref(showAnnotationTable),
      "onUpdate:show-annotations-table": _cache[5] || (_cache[5] = ($event: any) => (_isRef(showAnnotationTable) ? (showAnnotationTable).value = $event : null)),
      exportable: ""
    }, {
      export: _withCtx(() => [
        _createVNode(ExportData, {
          "available-columns": ['conversion_date'].concat(_unref(metrics)),
          "selected-columns": ['conversion_date'].concat(_unref(metrics)),
          "always-selected-columns": ['conversion_date'],
          "column-headers": _unref(headers),
          "report-name": 
            (_unref(getCurrentProgramName) + '_chart_' + _unref(dateFrom) + '_' + _unref(dateTo))
              .toLowerCase()
              .split(' ')
              .join('_')
          ,
          "exportable-data": _unref(exportData),
          "order-data-by": "conversion_date",
          "order-data-direction": "asc"
        }, null, 8, ["available-columns", "selected-columns", "column-headers", "report-name", "exportable-data"])
      ]),
      _: 1
    }, 8, ["headers", "metrics", "first-metric", "second-metric", "chart-type", "interval", "show-annotations-table"]),
    _createVNode(_unref(VueApexCharts), {
      ref: "taxonomyOneChart",
      type: _unref(typeOfChart),
      options: _unref(chartOptionsCompute),
      series: _unref(computedSeries),
      height: "350"
    }, null, 8, ["type", "options", "series"]),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      _createVNode(ChartAnnotations, {
        "show-annotations": "",
        "show-annotations-table": _unref(showAnnotationTable)
      }, null, 8, ["show-annotations-table"])
    ], 1024))
  ]))
}
}

})